module.exports = __webpack_public_path__ + "static/media/pathfinderr52.84cc95fe.jpg";